"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCALIZED_TEXT_MESSAGE = exports.ELEMENT_VALIDATION_WARNINGS = exports.DEPRECATION_WARNINGS = void 0;
const DEPRECATION_WARNINGS_SUFFIX = ' For more information, please see Breaking Change information at https://pages.github.concur.com/coreui/docs/nui-widgets/docs#breaking-changes.';
const DEPRECATION_WARNINGS = exports.DEPRECATION_WARNINGS = {
  PLACEHOLDER: `WARNING: an example message.${DEPRECATION_WARNINGS_SUFFIX}`,
  TABGROUP: 'WARNING: TabGroup is deprecated and will be removed in the future. Please use TabBar instead.'
};
const ELEMENT_VALIDATION_WARNINGS = exports.ELEMENT_VALIDATION_WARNINGS = {
  BREADCRUMB_STRINGS_NOT_RECOMMENDED: "Breadcrumbs should always contain a link for each crumb. Please add a surrounding <a> or <Link> tag with an appropriate URL to ALL Breadcrumb.Item's.",
  DATAGRID_CAPTION_REQUIRED: `
    DataGrid must have at least one of "title" OR "summary" set to a localized string, for its "caption" property.
    This is useful for assistive technologies like screen readers etc.
    For example:
    <DataGrid
        caption={{
            title: 'User Details', //localize this string
            summary: 'This table contains information about our users' //localize this string
        }}
    ...otherProps
    />`,
  CHECKBOX_HIDDEN_LABEL_REQUIRED: 'Checkboxes with hidden labels cannot be marked as required.',
  TIMEPICKER_STEP_NOT_ALLOWED: 'TimePicker step values cannot be less than 1'
};
const LOCALIZED_TEXT_MESSAGE = id => `CoreUI maintains a set of default localized strings. Please use the following id: \`${id}\`.`;
exports.LOCALIZED_TEXT_MESSAGE = LOCALIZED_TEXT_MESSAGE;